/**
 * ISI Preview Panel Functionality
 * Handles expand/collapse, scroll visibility, and full content display
 *
 * @package ppzms
 */

class ISIPreviewPanel {
	static isExpanded = false;
	static isMinimized = false;

	constructor() {
		this.previewPanel = document.querySelector('[data-isi-preview]');
		this.fullContent = document.querySelector('.isi-full-content');
		this.expandedContent = document.querySelector('[data-isi-expanded-content]');

		if (!this.previewPanel || !this.fullContent) {
			return;
		}

		this.init();
	}

	setMinimized(minimized) {
		ISIPreviewPanel.isMinimized = minimized;
		if (minimized) {
			this.previewPanel.classList.add('is-minimized');
		} else {
			this.previewPanel.classList.remove('is-minimized');
		}
	}

	init() {
		const expandTriggers = this.previewPanel.querySelectorAll('[data-isi-expand-trigger]');
		expandTriggers.forEach((trigger) => {
			trigger.addEventListener('click', () => this.toggleExpanded());
		});

		window.addEventListener('scroll', () => this.handleScroll());
		window.addEventListener('resize', () => this.handleResize());

		this.handleScroll();
		this.updateOverlayState();
	}

	handleResize() {
		this.handleScroll();
		this.updateOverlayState();
	}

	updateOverlayState() {
		if (ISIPreviewPanel.isExpanded) {
			document.body.classList.add('isi-overlay-active');
		} else {
			document.body.classList.remove('isi-overlay-active');
		}
	}

	toggleExpanded() {
		ISIPreviewPanel.isExpanded = !ISIPreviewPanel.isExpanded;

		if (ISIPreviewPanel.isExpanded) {
			this.setMinimized(false);
			this.previewPanel.classList.add('is-expanded');
		} else {
			this.previewPanel.classList.remove('is-expanded');
			this.setMinimized(true);
		}

		const expandTriggers = this.previewPanel.querySelectorAll('[data-isi-expand-trigger]');
		expandTriggers.forEach((trigger) => {
			trigger.setAttribute('aria-expanded', ISIPreviewPanel.isExpanded);

			const openIcon = trigger.querySelector('.isi-icon-open');
			const closeIcon = trigger.querySelector('.isi-icon-close');
			if (openIcon && closeIcon) {
				if (ISIPreviewPanel.isExpanded) {
					openIcon.style.display = 'none';
					closeIcon.style.display = 'block';
				} else {
					openIcon.style.display = 'block';
					closeIcon.style.display = 'none';
				}
			}
		});

		this.updateOverlayState();
	}

	handleScroll() {
		const previewPanelRect = this.previewPanel.getBoundingClientRect();
		const fullContentRect = this.fullContent.getBoundingClientRect();
		const shouldHidePreview = previewPanelRect.top > fullContentRect.top;

		if (shouldHidePreview) {
			this.previewPanel.classList.add('is-hidden');
		} else {
			this.previewPanel.classList.remove('is-hidden');
		}
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		document.body.classList.remove('isi-overlay-active');
		new ISIPreviewPanel();
	});
} else {
	document.body.classList.remove('isi-overlay-active');
	new ISIPreviewPanel();
}
